import styled from '@emotion/styled';

const TableBody = styled.tbody`
  tr:first-of-type td {
    border-top: none;
  }
`;

export default TableBody;
